import { Link } from 'react-router';

import { Card, PageContainer } from '@shared';

import { RegisterForm } from '@/features/auth/RegisterForm';
import { useTranslations } from '@/i18n/client';

export function RegisterPage() {
  const t = useTranslations('auth.register');

  return (
    <PageContainer className="md-auth md-register-page flex min-h-full items-start justify-center px-6 py-12 max-sm:w-full max-sm:px-0 max-sm:py-4">
      <Card
        title={t('title')}
        className="max-sm:box-border max-sm:w-full max-sm:p-4 max-sm:[&_p]:wrap-anywhere"
      >
        <p className="md-auth__subtitle">{t('subtitle')}</p>
        <RegisterForm />
        <p className="md-auth__link mt-6 text-center leading-[1.5]">
          <Link to="/login">{t('loginLink')}</Link>
        </p>
      </Card>
    </PageContainer>
  );
}
